import { render, staticRenderFns } from "./HeavyPackageShipmentForm.vue?vue&type=template&id=dddd525a&scoped=true"
import script from "./HeavyPackageShipmentForm.vue?vue&type=script&lang=js"
export * from "./HeavyPackageShipmentForm.vue?vue&type=script&lang=js"
import style0 from "./HeavyPackageShipmentForm.vue?vue&type=style&index=0&id=dddd525a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dddd525a",
  null
  
)

export default component.exports